import AOS from "aos";
import React,{useEffect} from "react";
import Carousel from "react-bootstrap/Carousel";


const HomepageThirdSection = () => {
  useEffect(()=>{
    AOS.init();
    window.scroll(0,0)
  },[]);
  return (
    <div className="container-fluid" id="homepage-third-section">
        <div className="row top-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
            <h1>Our Projects</h1>
            <p>"Revolutionizing industries with cutting-edge automation solutions. From robotics to streamlined processes, we optimize efficiency and enhance productivity for seamless operations. Your future starts here."</p>
        </div>
      <div className="row slider-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
        <Carousel className="slider" pause={"hover" | false}>
          <Carousel.Item interval={5000} className="slider-item">
            <div className="row">
              <div className="col project-1">
                <h4>Panel Testing</h4>
              </div>
              <div className="col project-2">
                <h4>Panel Manufacturing</h4>
              </div>
              <div className="col project-3">
                <h4>Panel Testing</h4>
              </div>
            </div>
          </Carousel.Item>
          <Carousel.Item interval={5000} className="slider-item">
          <div className="row">
              <div className="col project-4">
                <h4>Panel </h4>
              </div>
              <div className="col project-5">
                <h4>Solar Water Tank</h4>
              </div>
              <div className="col project-6">
                <h4>Flow Meter Project</h4>P
              </div>
            </div>
          </Carousel.Item>
          
        </Carousel>
      </div>
    </div>
  );
};

export default HomepageThirdSection;
